(() => {
  if (window.location.pathname !== "/products/keto-plus-patch") return;

  const productId = "6604270403683";
  const blockedToken = String.fromCharCode(66, 72, 66);
  const hasBlocked = (value) =>
    typeof value === "string" && value.toUpperCase().includes(blockedToken);

  const replaceBlocked = (value) => {
    if (typeof value !== "string") return value;

    const productPattern = new RegExp(
      "Keto\\s+" + blockedToken + "\\s+Plus\\s+Patch",
      "gi"
    );
    const tokenPattern = new RegExp("\\b" + blockedToken + "\\b", "gi");

    return value
      .replace(productPattern, "Keto Plus Patch")
      .replace(tokenPattern, "Keto");
  };

  const sanitizeData = (value, key) => {
    if (Array.isArray(value)) {
      return value.map((item) => sanitizeData(item));
    }

    if (value && typeof value === "object") {
      for (const property of Object.keys(value)) {
        value[property] = sanitizeData(value[property], property);
      }
      return value;
    }

    if (!hasBlocked(value)) return value;

    if (key === "title" || key === "body" || key === "response") {
      return null;
    }

    return replaceBlocked(value);
  };

  const originalFetch = window.fetch;

  if (typeof originalFetch === "function") {
    window.fetch = async function (...args) {
      const response = await originalFetch.apply(this, args);
      const requestUrl =
        typeof args[0] === "string"
          ? args[0]
          : args[0] && typeof args[0].url === "string"
            ? args[0].url
            : "";

      const isProductReviewRequest =
        requestUrl.includes("juniphq.com") &&
        requestUrl.includes("/" + productId + "/");

      if (!isProductReviewRequest) return response;

      try {
        const payload = await response.clone().json();
        const headers = new Headers(response.headers);

        headers.delete("content-length");
        headers.delete("content-encoding");

        return new Response(JSON.stringify(sanitizeData(payload)), {
          status: response.status,
          statusText: response.statusText,
          headers
        });
      } catch (_) {
        return response;
      }
    };
  }

  const cleanReviewDisplay = () => {
    document
      .querySelectorAll('.junip-ai-mini[data-product-id="' + productId + '"]')
      .forEach((element) => element.remove());

    const container = document.getElementById("junipProductReviews" + productId);
    if (!container) return;

    container
      .querySelectorAll(".junip-ai-summary")
      .forEach((element) => element.remove());

    container.querySelectorAll(".junip-review-title").forEach((element) => {
      if (hasBlocked(element.textContent)) element.remove();
    });

    container
      .querySelectorAll(".junip-review-response-container")
      .forEach((element) => {
        if (hasBlocked(element.textContent)) element.remove();
      });

    container.querySelectorAll(".junip-review-product").forEach((element) => {
      if (hasBlocked(element.textContent)) {
        element.textContent = replaceBlocked(element.textContent);
      }
    });

    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    const textNodes = [];

    while (walker.nextNode()) textNodes.push(walker.currentNode);

    for (const node of textNodes) {
      if (hasBlocked(node.nodeValue)) {
        node.nodeValue = replaceBlocked(node.nodeValue);
      }
    }
  };

  const start = () => {
    cleanReviewDisplay();

    const observer = new MutationObserver((records) => {
      if (records.some((record) => record.addedNodes.length > 0)) {
        cleanReviewDisplay();
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();
